<div class="dropdown">
  <button (click)="toggleDropdown()" class="profile-dropdown-toggle" [ngClass]="{ open: showDropdown }">
    <span class="dropdown-title-container">
      <b>Profile:</b> <span class="dropdown-title">{{ selectedOptionLabel }}</span>
    </span>
    <img src="../../../../assets/images/icons/chevron-right.svg" alt="chevron icon" />
  </button>
  <div class="dropdown-content" [ngClass]="{ open: showDropdown }">
    <div class="dropdown-container">
      <ng-content></ng-content>
    </div>
  </div>
</div>
